const RELOAD_KEY = 'chunkReloadAt';
const RELOAD_GUARD_MS = 10_000;

// Verlässt man die Seite, bricht der Browser laufende Downloads ab, und Safari meldet das als fehlgeschlagenen
// Import. Das ist kein veralteter Chunk; Neuladen unterbräche die Navigation zur nächsten Seite. Safari bricht
// schon beim Start der Navigation ab, deshalb `beforeunload` (ohne Rückfrage) und nicht erst `pagehide`.
let leavingAt = 0;
const markLeaving = () => { leavingAt = Date.now(); };
window.addEventListener('beforeunload', markLeaving);
window.addEventListener('pagehide', markLeaving);
window.addEventListener('pageshow', () => { leavingAt = 0; });

/**
 * Nach einem Deploy liefert der Server die Code-Dateien der alten Version nicht mehr aus. Wer sie noch
 * offen hat (ohne Service Worker oder in einem zweiten Tab nach "Jetzt aktualisieren"), bekommt beim
 * Öffnen einer noch nicht geladenen Seite einen Fehler. Ein einmaliges Neuladen holt die neue Version.
 * Die Sperre verhindert eine Endlosschleife, falls der Fehler bleibt; offline würde Neuladen die App
 * ganz verlieren. Gibt zurück, ob neu geladen wird.
 */
export function reloadForNewVersion(): boolean {
    if (!navigator.onLine || Date.now() - leavingAt < RELOAD_GUARD_MS) return false;
    try {
        const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
        if (Date.now() - last < RELOAD_GUARD_MS) return false;
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
        // Ohne sessionStorage keine Sperre: lieber den Fehler anzeigen als riskieren, endlos neu zu laden
        return false;
    }
    window.location.reload();
    return true;
}
